export const LANGUAGE_COUNT = 28
export const VOICES_COUNT = 240
